export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/carInspection.126ec6eb.svg","height":152,"width":152,"blurWidth":0,"blurHeight":0};